<template>
  <div v-if="data.length > 0">
    <div class="header-tab" v-on:click="toggle('comment')">
      <h3>
        {{ $t("new.title156")
        }}<!--  -->
        <span><p>&#128317;</p></span>
      </h3>
    </div>
    <div class="primarylists nqt__priList" v-if="comment">
      <div class="lessons lessons-new">
        <ul class="clear">
          <li
            v-for="(item, index) in data"
            :key="index"
            @click="nextPageDetailsCourse(item)"
          >
            <div>
              <!-- Ảnh -->
              <div class="img vaa">
                <template
                  v-if="item.courseCover == null || item.courseCover == ''"
                >
                  <img src="../../../../static/images/temppic.jpg" alt="/" />
                </template>
                <template v-else>
                  <template v-if="item.courseCover.match(regExp)">
                    <iframe
                      width="100% !important"
                      height="100% !important"
                      :src="item.courseCover"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    >
                    </iframe>
                  </template>
                  <template v-else>
                    <img :src="item.courseCover" alt="/"  @error="setAltCourse" />
                  </template>
                </template>
              </div>
              <div class="lessontitle_MB">
                <div class="lessontitle" style="-webkit-box-orient: vertical;">
                  {{ item.courseName }}
                </div>
              </div>
              <div class="startAndPrice">
                <!-- Giá tiền -->
                <span v-if="item.coursePrice >= 0" class="priceIndex">
                  <div v-if="item.offSelf == 100 || item.coursePrice == 0">
                                        <span class="free-course">{{ domainNameCurrent === DOMAIN_NAME ? $t("new.title291") : $t("new.title214") }}</span>
                  </div>
                  <div v-else>
                    <template
                      v-if="
                        (item.offSelf > 0 && item.offSelf != null) ||
                          item.offSelf != ''
                      "
                    >
                      <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                      {{
                        (item.coursePrice - item.coursePriceDiscount)
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                    </template>
                    <template v-else>
                      <span v-if="beforCurren">{{ $t("new.title121") }}</span>
                      {{
                        item.coursePrice
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}
                      <span v-if="afterCurren">{{ $t("new.title121") }}</span>
                    </template>
                  </div>
                </span>
                <!-- Sao đánh giá -->
                <span class="startIndex">
                  <div
                    class="Stars"
                    :style="'--rating:' + item.courseEvaluate"
                  ></div>
                </span>
              </div>
              <div class="borderIndex"></div>
              <!-- Tên khoá học -->
              <div class="lessontitle_PC">
                <div class="lessontitle" style="-webkit-box-orient: vertical;">
                  {{ item.courseName }}
                </div>
              </div>
              <div
                v-if="
                  (item.offSelf > 0 && item.offSelf != null) ||
                    item.offSelf != ''
                "
                class="hot-position"
              >
                <div class="ishot-r">
                  <p>-</p>
                  <p>{{ item.offSelf }}%</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <loading class="loading--lesson" :showLoading="!isLoadData" />
    </div>
  </div>
</template>

<script>
import loading from "@/components/loading/loading";
import domainName from "../../../../env";
    export default {
        data() {
            return {
                comment : true,
                data: [],
                outlineInfo: eval("(" + this.$route.query.outlineInfo + ")"),
                listDatarelated: [],
                isLoadData: true,
                afterCurren : false,
                beforCurren : false,
                regExp: /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/,
                templateYoutubeSrc: "https://www.youtube.com/embed/",
                domainNameCurrent: window.location.host,
                DOMAIN_NAME: domainName.DOMAIN_NAME_SANRITSU,
    };
  },
  components: {
    loading
  },
  computed: {
    mobile() {
      return this.$store.getters["header/mobile"];
    }
  },
  async created() {
    await this.init();
  },
  mounted() {
    this.checkCurren();
  },
  watch: {},
  methods: {
    async init() {
      if (this.outlineInfo.listId.length > 0) {
        this.isLoadData = false;
        const self = this;
        Promise.all(
          this.outlineInfo.listId.map(item => {
            return self.getDataRelatedCourse(item);
          })
        ).then(function(results) {
          self.isLoadData = true;
          let listGetDataRelated = [];
          results.forEach(value => {
            value.forEach(element => {
              listGetDataRelated.push(element);
            });
          });
          /// Them list id catalog
          listGetDataRelated.forEach(function(item) {
            listGetDataRelated.forEach(function(value) {
              if (item.courseId == value.courseId) {
                item.listCatalogId.push(value.idCatalog);
              }
            });
            if (item.courseCover.match(self.regExp)) {
              let temp = item.courseCover.split("https://youtu.be/");
              item.courseCover = self.templateYoutubeSrc + temp[1];
            }
          });
          /// loc khoa hoc trung nhau
          let checkArrayCourseId = [];
          let arrayListData = [];
          listGetDataRelated.forEach(function(item) {
            /// check khoa hoc trung nhau
            if (checkArrayCourseId.indexOf(item.courseId) < 0) {
              checkArrayCourseId.push(item.courseId);
              arrayListData.push(item);
            }
          });
          /// loc khoa hoc trung voi khoa hien tai
          arrayListData.forEach((el, index) => {
            if (el.courseId == self.outlineInfo.courseId) {
              arrayListData.splice(index, 1);
            }
          });
          self.data = arrayListData;
        });
      } else {
        this.isLoadData = false;
        this.$api
          .post("/evaluate/getCourseByIdCatalog", {
            catalogId: this.outlineInfo.catalogId
          })
          .then(response => {
            this.isLoadData = true;
            response.data.forEach(item => {
              item["listCatalogId"] = [];
              item["idCatalog"] = this.outlineInfo.catalogId;
              if (item.courseCover.match(this.regExp)) {
                let temp = item.courseCover.split("https://youtu.be/");
                item.courseCover = this.templateYoutubeSrc + temp[1];
              }
            });
            response.data.forEach((el, index) => {
              if (el.courseId == this.outlineInfo.courseId) {
                response.data.splice(index, 1);
              }
            });
            this.data = response.data;
          })
          .catch(err => {});
      }
    },
    setAltCourse(event) { 
    	event.target.src = "../../../static/images/temppic.jpg" ;
    },
    getDataRelatedCourse: function(params) {
      const self = this;
      return new Promise((resolve, reject) => {
        this.$api
          .post("/evaluate/getCourseByIdCatalog", {
            catalogId: params
          })
          .then(response => {
            response.data.forEach(item => {
              item["listCatalogId"] = [];
              item["idCatalog"] = params;
            });
            resolve(response.data);
          })
          .catch(err => {
            reject(err.response);
          });
      });
    },
    nextPageDetailsCourse(params) {
      let dataUrls = {
        type: this.outlineInfo.type,
        courseId: params.courseId,
        catalogId: params.idCatalog,
        listId: params.listCatalogId
      };
      // Đi đến chi tiết bán khóa học
      this.$emit("loadPageClick", dataUrls);
      this.$router.push({
        path: "/home/detailsSelfCourse",
        query: {
          outlineInfo: JSON.stringify(dataUrls)
        }
      });
    },
    toggle(value) {
      if (value == "comment") {
        this.comment = !this.comment;
      }
    },
    // Curency position
    checkCurren() {
      if (this.$lang()) {
        if (this.$lang() == 3 || this.$lang() == 1) {
          this.beforCurren = true;
        } else {
          this.afterCurren = true;
        }
      }
    }
  }
};
</script>
<style scoped>
.primarylists .lessons.lessons-new ul li {
  width: calc(25% - 16px)!important;
}
.lessons {
  margin-top: 0px;
}
.Stars {
    --star-size: 15px;
    --star-color: #a8a8a8;
    --star-background: #cb0d0d;
    --percent: calc(var(--rating) / 5 * 100%);  
    display: inline-block;
    font-size: var(--star-size);
    font-family: Times;
    line-height: 1;
}
.Stars::before {
  content: "★★★★★";
  letter-spacing: 3px;
  background: linear-gradient(
    90deg,
    var(--star-background) var(--percent),
    var(--star-color) var(--percent)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.like-ps {
    top: 0px !important;
    left: 2px !important;
}
.primarylists > ul > li {
    padding-bottom: 50px;
    overflow: hidden;
}
.vn .primarylists .lessons ul li > div {
    padding: 0px 0px 15px 0px;
}
.primarylists ul li .titles {
    height: 35px;
    width: 1000px;
    padding-bottom: 5px;
    color: black;
    margin-bottom: 10px;
    display: flex;
    inline-size: max-content;
}
.primarylists ul li .titles img {
    width: 32px;
    height: 32px;
    margin-top: 1px;
}
.primarylists ul li .titles .title {
    font-size: 24px;
    padding: 0 20px 0 10px;
    line-height: 35px;
    cursor: pointer;
    font-weight: bold;
}
.primarylists ul li .titles .more {
    font-size: 16px;
    line-height: 35px;
    cursor: pointer;
    padding-right: 20px;
}
.primarylists ul li .titles .more a {
    color: black;
}
.more a {
    color: #fff !important;
}
.free-course{
    color:#cb0d0d;
    padding-right:20px;
}
.primarylists ul li .titles .title:hover {
    color: #02adff;
}
.primarylists ul li .titles .more :hover {
    color: #02adff;
}
.primarylists .secondlist {
    height: 100%;
    font-size: 16px;
}
.primarylists .secondlist ul li {
    float: left;
    padding: 3px 10px;
    cursor: pointer;
    margin-right: 16px;
    background: #666;
    border-radius: 15px;
    color: white;
}
.primarylists .secondlist ul li.choose {
    background: lightskyblue;
}
.primarylists .lessons ul {
    height: auto;
    overflow: hidden;
    transform: translateX(5px);
}
.primarylists .lessons ul li {
    width: 350px;
    height: auto;
    float: left;
    box-sizing: border-box;
    background: #333;
    background-clip: padding-box;
    margin-right: 10px;
    margin-bottom: 10px;
    border-radius: 10px;
    overflow: hidden;
    border-color: #fff !important;
    /* background-color: #f1f1f1 !important; */
    box-shadow: 0px 1px 7px 1px rgb(0 0 0 / 20%) !important;
    border: #dadae8;
}
.primarylists .lessons ul li .img {
    height: 100px;
    width: 100%;
    overflow: hidden;
}
.primarylists .lessons ul li .img img {
    width: 100%;
    transition: all 0.25s ease-in-out;
    -moz-transition: all 0.25s ease-in-out;
    -webkit-transition: all 0.25s ease-in-out;
    -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
    padding: 10px 10px 0px 10px !important;
    margin: 5px 0 0px!important;
    color: #f8f8f8;
    font-size: 15px;
    cursor: pointer;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
    color: lightskyblue;
}
.primarylists .lessons .startAndPrice {
    padding: 5px 10px !important;
    margin: 5px 0px 5px 0px!important;
}
.primarylists .lessons .borderIndex {
    border-bottom: 1px solid #0071c5;
}
.primarylists .lessons .startAndPrice .priceIndex {
    float: right;
    font-size: 15px;
    font-weight: 600;
}
.primarylists .lessons .introduce {
    padding: 0 10px;
    color: #999;
    font-size: 12px;

    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
}
.container,.bigCourse {
    width: 1200px;
    margin: 0 auto;
}

@media screen and (min-width: 1000px) and (max-width: 1200px) {
    .container,.bigCourse {
        width: 1000px;
    }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
    .container,.bigCourse {
        width: 800px;
    }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
    .container,.bigCourse {
        width: 600px;
    }
}
@media screen and (max-width: 600px) {
    .container,.bigCourse {
        width: 400px;
    }
}
.vaa :hover {
    transform: scale(1.05, 1.05);
    cursor: pointer;
}
.disabledCourse {
    display: none;
}
.primarylists .lessons .lessontitle_MB {
    display: none;
}
/* style MB */
@media (max-width: 480px) {
  .primarylists .lessons.lessons-new ul li {
    width: calc(100% - 10px) !important;
  }
  .primarylists .lessons .borderIndex {
    border-bottom: none !important;
  }
  .primarylists .lessons .startAndPrice .priceIndex {
    float: none !important;
  }
  .Stars {
    --star-size: 25px !important;
  }
  .primarylists .lessons .lessontitle {
    padding: 0px 5px 0px 5px !important;
    /* margin: 0px 0 15px!important; */
    /* height: 35px; */
  }
  .primarylists .lessons .lessontitle_PC {
    display: none !important;
  }
  .primarylists .lessons .lessontitle_MB {
    display: unset !important;
  }
  .priceIndex {
    padding: 0px 5px 0px 5px !important;
  }
  .startIndex {
    padding: 0px 5px 0px 5px !important;
  }
}
@media screen and (min-width: 481px) and (max-width: 780px) {
    .primarylists .lessons .startAndPrice .priceIndex {
        float: none !important;
    }
    .primarylists .lessons .startAndPrice .priceIndex{
        font-size: 12px !important;
        float: right !important;
    }
    .Stars{
        --star-size : 13px !important;
    }
}
 .header-tab h3{
    background-color:#DDDDDD;
    padding: 10px;
    font-weight: 400;
    margin-bottom: 10px;
    font-size: 16px;
}
.header-tab span{
    float: right;
    cursor: pointer;
}
.header-tab span p{
    margin: 0px;
}
.header-tab {
    cursor: pointer;
}
.cart_moblie {
    width: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/defineSelfCourse/detailsSelfCourse/relatedCourse.vue